
import { mapGetters } from "vuex"
import { mdiClose, mdiEmoticonOutline } from "@mdi/js"
import OImage from "@/components/base/image/OImage"
export default {
    name: "EmojiSelector",
    components: { OImage },
    emits: ["input", "selected"],
    props: {
        /** An optional livestream-id to set a emoji scope. Uses all otherwise  */
        streamId: {
            type: [Number, String],
            default: "",
        },
        value: {
            type: Boolean,
            default: false,
        },
        filter: {
            type: String,
            default: "",
        },
    },
    data: () => {
        return {
            mdiClose: mdiClose,
            mdiEmoticonOutline: mdiEmoticonOutline,
            premiumHint: false,
        }
    },
    computed: {
        showEmojiMenu: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit("input", val)
            },
        },
        filteredEmojis() {
            return this.emojis.filter((e) => e.name.includes(this.filter ?? ""))
        },
        ...mapGetters("livestream", ["emojis"]),
    },
    methods: {
        handleEmojiSelect(emoji) {
            if (emoji.is_premium) {
                this.premiumHint = true
                return
            }
            this.showEmojiMenu = false
            this.$emit("selected", emoji)
        },
        toggleMenu() {
            this.showEmojiMenu = !this.showEmojiMenu
            this.premiumHint = false
        },
        getImage(rawLink) {
            if (rawLink.endsWith("=") || rawLink.startsWith("/")) return rawLink
            return "/" + rawLink
        },
        onLogin() {
            this.$store.dispatch("account/showAuth")
        },
    },
}
